export default __webpack_public_path__ + "static/media/Raider's Gloves of Woven Clouds.d0912056.jpg";